import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import TextInput from '../../inputs/text-input';
import { RootState } from '../../../store';
import { IOBOOrderCertificates } from '../../../../src/models/obo-orderCertificates';
import { submitOrderCertificatesOrder } from '../../../../src/store/obo/obo-actions';
import { Navigation } from '../../../global-functions';
import { IResult } from '../../../models/result-models';
import { ISession } from '../../../../src/models/pro-sites';
import { WrappedComponentProps, injectIntl } from 'react-intl';
interface IOrderCertificates {
    session: ISession | null;
    submitOrderCertificatesOrder: (
        request: IOBOOrderCertificates
    ) => Promise<IResult<boolean>>;
}

const OrderCertificates = ({
    session,
    submitOrderCertificatesOrder,
}: IOrderCertificates) => {
    const intl = useIntl();
    const [promotionName, setPromotionName] = useState('');
    const [certificatePartNumber, setCertificatePartNumber] = useState('');
    const [totalQtyOfCertificates, setTotalQtyOfCertificates] = useState('');
    const [numberOfMonths, setNumberOfMonths] = useState('');
    const [comments, setComments] = useState('');

    const handleSubmit = async () => {
        const request: IOBOOrderCertificates = {
            BillTo: session!.orderOnBehalfOfAccount!.accountNumber,
            BillToLocationId: session!.orderOnBehalfOfAccount!.locationId
                ? session!.orderOnBehalfOfAccount!.locationId
                : session!.orderOnBehalfOfAccount!.accountNumber,
            ShipTo: session!.orderOnBehalfOfAccount!.shipToAccounts[0]
                .accountNumber,
            ShipToLocationId: session!.orderOnBehalfOfAccount!.shipToAccounts[0]
                .locationId
                ? session!.orderOnBehalfOfAccount!.shipToAccounts[0].locationId
                : session!.orderOnBehalfOfAccount!.shipToAccounts[0]
                      .accountNumber,
            PromotionName: promotionName,
            CertificatePartNumber: certificatePartNumber,
            QuantityOfCertificates: totalQtyOfCertificates,
            QuantityOfMonths: numberOfMonths,
            Comments: comments,
        };
        await submitOrderCertificatesOrder(request);
        Navigation.pushExternal('/prosite/estore');
    };

    return (
        <>
            <h2 style={{ color: 'red' }}>
                <FormattedMessage
                    id="Order Certificates"
                    defaultMessage="Order Certificates"
                />
            </h2>
            {session!.orderOnBehalfOfAccount && (
                <div className="row, rounded-corner-grey-background">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4
                                style={{
                                    borderBottom: '1px solid black',
                                }}
                            >
                                <strong>
                                    {intl.formatMessage({
                                        id: 'CERTIFICATE_ORDER_FORM',
                                        defaultMessage:
                                            'CERTIFICATE ORDER FORM',
                                    })}{' '}
                                </strong>
                            </h4>
                        </div>
                    </div>
                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <fieldset disabled={true}>
                                <TextInput
                                    name="billToAccount"
                                    label="Bill To Account"
                                    value={
                                        session!.orderOnBehalfOfAccount!
                                            .accountNumber
                                    }
                                    maxLength={256}
                                    onChange={(event) => void ''}
                                />
                            </fieldset>
                        </div>
                    </div>
                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <fieldset disabled={true}>
                                <TextInput
                                    name="shipToAccount"
                                    label="Ship To Account"
                                    value={
                                        session!.orderOnBehalfOfAccount!
                                            .shipToAccounts[0]!.accountNumber
                                    }
                                    maxLength={256}
                                    onChange={(event) => void ''}
                                />
                            </fieldset>
                        </div>
                    </div>

                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <TextInput
                                name="promotionName"
                                label="Promotion Name"
                                value={promotionName}
                                maxLength={256}
                                onChange={(event) =>
                                    setPromotionName(event.target.value)
                                }
                                required={true}
                            />
                        </div>
                    </div>

                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <TextInput
                                name="certificatepartnumber"
                                label="Certificate Part Number"
                                value={certificatePartNumber}
                                maxLength={30}
                                onChange={(event) =>
                                    setCertificatePartNumber(event.target.value)
                                }
                                required={true}
                            />
                        </div>
                    </div>

                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <TextInput
                                name="totalqtyofcertificates"
                                label="Total Qty of Certificates"
                                value={totalQtyOfCertificates}
                                maxLength={3}
                                onChange={(event) =>
                                    setTotalQtyOfCertificates(
                                        event.target.value
                                    )
                                }
                                required={true}
                            />
                        </div>
                    </div>

                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <TextInput
                                name="numberofmonths"
                                label="* Number of Months"
                                value={numberOfMonths}
                                maxLength={3}
                                onChange={(event) =>
                                    setNumberOfMonths(event.target.value)
                                }
                                required={true}
                            />
                        </div>
                    </div>

                    <div className="row gutter-top">
                        <div className="col-sm-1"></div>
                        <div className="col-sm-11">
                            <TextInput
                                name="comments"
                                label="Comments"
                                value={comments}
                                maxLength={1024}
                                onChange={(event) =>
                                    setComments(event.target.value)
                                }
                                required={false}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 gutter-top">
                            <span>
                                *
                                {intl.formatMessage({
                                    id: 'Total_quantity_of_certificates',
                                    defaultMessage: `Total quantity of certificates will be split
                                across months`,
                                })}
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="modal-footer">
                <span className="pull-right">
                    <button
                        className="btn btn-default"
                        onClick={handleSubmit}
                        disabled={
                            !(
                                certificatePartNumber!.length > 0 &&
                                totalQtyOfCertificates!.length > 0 &&
                                numberOfMonths!.length > 0
                            )
                        }
                    >
                        {intl.formatMessage({
                            id: 'Submit_Order',
                            defaultMessage: 'Submit Order',
                        })}
                    </button>
                    <button
                        className="btn btn-info"
                        onClick={() => {
                            Navigation.pushExternal('/prosite/estore');
                        }}
                    >
                        {intl.formatMessage({
                            id: 'Cancel',
                            defaultMessage: 'Cancel',
                        })}
                    </button>
                </span>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
        submitOrderCertificatesOrder,
    };
};

const mapDispatchToProps = {
    submitOrderCertificatesOrder,
};

const OrderCertificatesContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderCertificates);

export default OrderCertificatesContainer;
